<cec-menu
  [title]="'Results' | translate"
  [dataSource]="service"
  (onCloseSideNav)="closeSideNav()"
></cec-menu>
<!-- @if (!(['xs', 'sm', 'md'] | breakpoint | async)) {
  <button mat-button [matMenuTriggerFor]="menu" aria-label="Toggle results menu" (click)="onGetResults()">
    <mat-icon>table_chart</mat-icon>
    {{'Results' | translate}}
  </button>
  <mat-menu #menu="matMenu">
    @for (result of standings; track result.competitionName) {
      <button mat-menu-item [matMenuTriggerFor]="submenu">
        <mat-icon>dialpad</mat-icon>
        <span>{{result.competitionName}}</span>
          <mat-menu #submenu="matMenu">
            @if (result.drivingReportsPerCrew.length) {
              <button mat-menu-item [matMenuTriggerFor]="drivingReportsMenu">
                <mat-icon>border_color</mat-icon>
                <span>{{'Driving reports' | translate}}</span>
                <mat-menu #drivingReportsMenu="matMenu">
                  @for (drivingReport of result.drivingReportsPerCrew; track drivingReport.stageName) {
                    <button mat-menu-item (click)="onSelectDrivingReport(result.id, drivingReport.stageId, drivingReport.crewNumber, drivingReport.id)">
                        <mat-icon>border_color</mat-icon>
                        <span>{{drivingReport.stageName}}</span>
                    </button>
                  }
                </mat-menu>
              </button>
            }
            @if (result.stageResults.length) {
              <button mat-menu-item [matMenuTriggerFor]="stageResultsMenu">
                <mat-icon>border_color</mat-icon>
                <span>{{'Stage Results' | translate}}</span>
                <mat-menu #stageResultsMenu="matMenu">
                    @for (stageResult of result.stageResults; track stageResult.name) {
                      <button mat-menu-item (click)="onSelectStageResult(result.id, stageResult.id)">
                        <mat-icon>border_color</mat-icon>
                        <span>{{stageResult.name}}</span>
                      </button>
                      <button mat-menu-item (click)="onSelectStageSpeedTrialResult(stageResult.id)">
                        <mat-icon>border_color</mat-icon>
                        <span>{{stageResult.name + ' speed trial'}}</span>
                      </button>
                    }
                </mat-menu>
              </button>
            }
            @if (result.roundResults.length) {
              <button mat-menu-item [matMenuTriggerFor]="roundResultsMenu">
                <mat-icon>border_color</mat-icon>
                <span>{{'Round Results' | translate}}</span>
                <mat-menu #roundResultsMenu="matMenu">
                  @for (roundResult of result.roundResults; track roundResult.name) {
                    <button mat-menu-item (click)="onSelectRoundResult(result.id, roundResult.id)">
                      <mat-icon>border_color</mat-icon>
                      <span>{{roundResult.name}}</span>
                    </button>
                    <button mat-menu-item (click)="onSelectRoundSpeedTrialResult(roundResult.id)">
                      <mat-icon>border_color</mat-icon>
                      <span>{{roundResult.name + ' speed trial'}}</span>
                    </button>
                  }
                </mat-menu>
              </button>
            }
            @if (result.competitionResults.length) {
              <button mat-menu-item (click)="onSelectCompetitionResult(result.id)">
                <mat-icon>border_color</mat-icon>
                <span>{{'Competition Results' | translate}}</span>
              </button>
              <button mat-menu-item (click)="onSelectCompetitionSpeedTrialResult(result.id)">
                <mat-icon>border_color</mat-icon>
                <span>{{'Speed Trial Results' | translate}}</span>
              </button>
            }
          </mat-menu>
        </button>
    }
    <mat-divider></mat-divider>
    @if (seasonResults) {
      <button mat-menu-item (click)="onSelectSeasonResult(seasonResults?.id, 'CEC')">
        <mat-icon>dialpad</mat-icon>
        <span>{{'Season ' + seasonResults?.name}}</span>
      </button>
    }
    @if (speedTrialSeasonResults) {
      <button mat-menu-item (click)="onSelectSeasonSpeedTrialResult(seasonResults?.id, 'CEC')">
        <mat-icon>dialpad</mat-icon>
        <span>{{ "Season speed trial " + speedTrialSeasonResults.name }}</span>
      </button>
    } -->
<!-- <button mat-menu-item>
      <mat-icon>dialpad</mat-icon>
      <span>{{'Speed trial' | translate}}</span>
    </button>
    <button mat-menu-item>
      <mat-icon>dialpad</mat-icon>
      <span>{{'Full results' | translate}}</span>
    </button> -->
<!-- </mat-menu>
} @else {
  <mat-expansion-panel [class.mat-elevation-z0]="true" (click)="onGetResults()">
    <mat-expansion-panel-header>
      <div class="list-item">
        <mat-icon>table_chart</mat-icon>
        {{'Results' | translate}}
      </div>
    </mat-expansion-panel-header>
    @for (result of standings; track result.competitionName) {
      <mat-expansion-panel [class.mat-elevation-z0]="true">
        <mat-expansion-panel-header>
          <div class="list-item">
            <mat-icon>dialpad</mat-icon>
            {{result.competitionName}}
          </div>
        </mat-expansion-panel-header>
        @if (result.drivingReportsPerCrew.length) {
          <mat-expansion-panel [class.mat-elevation-z0]="true">
            <mat-expansion-panel-header>
              <div class="list-item">
                <mat-icon>border_color</mat-icon>
                {{'Driving reports' | translate}}
              </div>
            </mat-expansion-panel-header>
            @for (drivingReport of result.drivingReportsPerCrew; track drivingReport.stageName) {
              <a mat-list-item (click)="onSelectDrivingReport(result.id, drivingReport.stageId, drivingReport.crewNumber, drivingReport.id)">
                <div class="list-item normal">
                  <mat-icon>border_color</mat-icon>
                  {{drivingReport.stageName}}
                </div>
              </a>
            }
          </mat-expansion-panel>
        }
        @if (result.stageResults.length) {
          <mat-expansion-panel [class.mat-elevation-z0]="true">
            <mat-expansion-panel-header>
              <div class="list-item">
                <mat-icon>border_color</mat-icon>
                {{'Stage Results' | translate}}
              </div>
              </mat-expansion-panel-header>
              @for (stageResult of result.stageResults; track stageResult.name) {
                <a mat-list-item (click)="onSelectStageResult(result.id, stageResult.id)">
                  <div class="list-item normal">
                    <mat-icon>border_color</mat-icon>
                    {{stageResult.name}}
                  </div>
                </a>
                <a mat-list-item (click)="onSelectStageSpeedTrialResult(stageResult.id)">
                  <div class="list-item normal">
                    <mat-icon>border_color</mat-icon>
                    {{stageResult.name + ' speed trial'}}
                  </div>
                </a>
              }
          </mat-expansion-panel>
        }
        @if (result.roundResults.length) {
          <mat-expansion-panel [class.mat-elevation-z0]="true">
            <mat-expansion-panel-header>
              <div class="list-item">
                <mat-icon>border_color</mat-icon>
                {{'Round Results' | translate}}
              </div>
            </mat-expansion-panel-header>
            @for (roundResult of result.roundResults; track roundResult.name) {
              <a mat-list-item (click)="onSelectRoundResult(result.id, roundResult.id)">
                <div class="list-item normal">
                  <mat-icon>border_color</mat-icon>
                  {{roundResult.name}}
                </div>
              </a>
              <a mat-list-item (click)="onSelectRoundSpeedTrialResult(roundResult.id)">
                <div class="list-item normal">
                  <mat-icon>border_color</mat-icon>
                  {{roundResult.name + ' speed trial'}}
                </div>
              </a>
            }
          </mat-expansion-panel>
        }
        @if (result.competitionResults.length) {
          <a mat-list-item (click)="onSelectCompetitionResult(result.id)">
            <div class="list-item normal">
              <mat-icon>border_color</mat-icon>
              {{'Competition Results' | translate}}
            </div>
          </a>
          <a mat-list-item (click)="onSelectCompetitionSpeedTrialResult(result.id)">
            <div class="list-item normal">
              <mat-icon>border_color</mat-icon>
              {{'Speed Trial Results' | translate}}
            </div>
          </a>
        }
      </mat-expansion-panel>
    }
    @if (seasonResults) {
      <a mat-list-item (click)="onSelectSeasonResult(seasonResults?.id, 'CEC')">
        <div class="list-item normal">
          <mat-icon>dialpad</mat-icon>
          {{'Season ' + seasonResults?.name}}
        </div>
      </a>
    }
    @if (speedTrialSeasonResults) {
      <a mat-list-item (click)="onSelectSeasonResult(seasonResults?.id, 'CEC')">
        <div class="list-item normal">
          <mat-icon>dialpad</mat-icon>
          {{ "Season speed trial " + speedTrialSeasonResults.name }}
        </div>
      </a>
    }
  </mat-expansion-panel>
} -->
